import { Outlet, createFileRoute } from "@tanstack/react-router";
import { NotFoundErrorPage } from "@/lib/error-boundary";
import { AuthGuard } from "@/lib/keycloak/auth-guard";

export const Route = createFileRoute("/_authenticated")({
	component: () => (
		<AuthGuard>
			<Outlet />
		</AuthGuard>
	),
	notFoundComponent: NotFoundErrorPage,
});
